import { gql } from '@apollo/client';
const UPDATE_SIZE_STANDARD_SIZE_NAME = gql `
  mutation UpdateSizeStandardSizeName($modelSpecificationSizeNameId: ID!, $name: String!) {
    updateModelSpecificationSizeName(
      modelSpecificationSizeNameId: $modelSpecificationSizeNameId
      name: $name
    ) {
      modelSpecificationSizeName {
        id
        name
      }
    }
  }
`;
export default UPDATE_SIZE_STANDARD_SIZE_NAME;
